export const ACTION_TYPES = {
  GET_TASKS_REQUEST: 'GET_TASKS_REQUEST',
  GET_TASKS_REQUEST_SUCCESS: 'GET_TASKS_REQUEST_SUCCESS',
  GET_TASKS_REQUEST_ERROR: 'GET_TASKS_REQUEST_ERROR',
  GET_SECTION_TASKS_REQUEST_SUCCESS: 'GET_SECTION__TASKS_REQUEST_SUCCESS',
  GET_SECTION_TASKS_REQUEST_ERROR: 'GET_SECTION_TASKS_REQUEST_ERROR',
  COPY_TASK_LINK: 'COPY_TASK_LINK',
  GET_TASK_REQUEST: 'GET_TASK_REQUEST',
  GET_TASK_REQUEST_SUCCESS: 'GET_TASK_REQUEST_SUCCESS',
  GET_TASK_REQUEST_ERROR: 'GET_TASK_REQUEST_ERROR',
  GET_TASK_BY_IDENTIFIER_REQUEST: 'GET_TASK_BY_IDENTIFIER_REQUEST',
  GET_TASK_BY_IDENTIFIER_REQUEST_SUCCESS:
    'GET_TASK_BY_IDENTIFIER_REQUEST_SUCCESS',
  GET_TASK_BY_IDENTIFIER_LEAN_REQUEST_SUCCESS:
    'GET_TASK_BY_IDENTIFIER_LEAN_REQUEST_SUCCESS',
  GET_TASK_BY_IDENTIFIER_REQUEST_ERROR: 'GET_TASK_BY_IDENTIFIER_REQUEST_ERROR',
  GET_RECURRING_TASKS_REQUEST_SUCCESS: 'GET_RECURRING_TASKS_REQUEST_SUCCESS',
  GET_RECURRING_TASKS_REQUEST_ERROR: 'GET_RECURRING_TASKS_REQUEST_ERROR',
  ADD_TASK_SUCCESS: 'ADD_TASK_SUCCESS',
  ADD_TASK_ERROR: 'ADD_TASK_ERROR',
  DELETE_TASK_REQUEST: 'DELETE_TASK_REQUEST',
  DELETE_TASK_REQUEST_SUCCESS: 'DELETE_TASK_REQUEST_SUCCESS',
  DELETE_TASK_REQUEST_ERROR: 'DELETE_TASK_REQUEST_ERROR',
  EDIT_TASK: 'EDIT_TASK',
  EDIT_TASK_SUCCESS: 'EDIT_TASK_SUCCESS',
  EDIT_TASK_REVERT: 'EDIT_TASK_REVERT',
  EDIT_TASK_CUSTOM_FIELD: 'EDIT_TASK_CUSTOM_FIELD',
  SET_TMP_TASK_PROPS: 'SET_TMP_TASK_PROPS',
  CLEAR_OPENED_TASK_ID: 'CLEAR_OPENED_TASK_ID',
  GET_USER_TASKS_REQUEST: 'GET_USER_TASKS_REQUEST',
  GET_USER_TASKS_REQUEST_SUCCESS: 'GET_USER_TASKS_REQUEST_SUCCESS',
  SEARCH_TASKS_REQUEST_SUCCESS: "SEARCH_TASKS_REQUEST_SUCCESS",
  GET_USER_TASKS_REQUEST_ERROR: 'GET_USER_TASKS_REQUEST_ERROR',
  ADD_COMMENT_TO_TASK: 'ADD_COMMENT_TO_TASK',
  DELETE_COMMENT_FROM_TASK: 'DELETE_COMMENT_FROM_TASK',
  UPDATE_TASK_EVENT: 'UPDATE_TASK_EVENT',
  ADD_TASK_EVENT: 'ADD_TASK_EVENT',
  ADD_SUBTASK_EVENT: 'ADD_SUBTASK_EVENT',
  REMOVE_TASK_EVENT: 'REMOVE_TASK_EVENT',
  SET_PROJECT_TASKS_FILTERS: 'SET_PROJECT_TASKS_FILTERS',
  SET_PROJECT_TASKS_SORTS: 'SET_PROJECT_TASKS_SORTS',
  SET_USER_TASKS_FILTERS: 'SET_USER_TASKS_FILTERS',
  GET_DASHBOARD_TASKS_REQUEST_SUCCESS: 'GET_DASHBOARD_TASKS_REQUEST_SUCCESS',
  GET_DASHBOARD_TASKS_REQUEST_ERROR: 'GET_DASHBOARD_TASKS_REQUEST_ERROR',
  TASKS_DRAG_N_DROP_ACTION: 'TASKS_DRAG_N_DROP_ACTION',
  TASKS_REORDER_ACTION: 'TASKS_REORDER_ACTION',
  TASKS_REORDER_EVENT: 'TASKS_REORDER_EVENT',
  ADD_TASK_CUSTOM_FIELD_ACTION: 'ADD_TASK_CUSTOM_FIELD_ACTION',
  UPDATE_TASK_CUSTOM_FIELD_ACTION: 'UPDATE_TASK_CUSTOM_FIELD_ACTION',
  DELETE_TASK_CUSTOM_FIELD_ACTION: 'DELETE_TASK_CUSTOM_FIELD_ACTION',
  CLEAR_USER_TASKS: 'CLEAR_USER_TASKS',
  BULK_ADD_TASKS_SUCCESS: 'BULK_ADD_TASKS_SUCCESS',
  GET_AI_TASKS_SUCCESS: 'GET_AI_TASKS_SUCCESS',
  REMOVE_PROJECT_FROM_TASK_SUCCESS: 'REMOVE_PROJECT_FROM_TASK_SUCCESS',
  ADD_TASK_TO_PROJECT_REQUEST_SUCCESS: 'ADD_TASK_TO_PROJECT_REQUEST_SUCCESS',
  ADD_TASK_TO_PROJECT_REQUEST_FAILURE: 'ADD_TASK_TO_PROJECT_REQUEST_FAILURE',
  OPEN_TASK_ACTION: 'OPEN_TASK_ACTION',
  DELETE_CUSTOM_FIELD_FROM_PROJECT: 'DELETE_CUSTOM_FIELD_FROM_PROJECT',
  GET_TASKS_INFINITE_LIST_FIRST_PAGE_SUCCESS: 'GET_TASKS_INFINITE_LIST_FIRST_PAGE_SUCCESS',
  GET_TASKS_INFINITE_LIST_NEXT_PAGE_REQUEST: 'GET_TASKS_INFINITE_LIST_NEXT_PAGE_REQUEST',
  GET_TASKS_INFINITE_LIST_NEXT_PAGE_SUCCESS: 'GET_TASKS_INFINITE_LIST_NEXT_PAGE_SUCCESS',
  GET_TASKS_INFINITE_LIST_NEXT_PAGE_ERROR: 'GET_TASKS_INFINITE_LIST_NEXT_PAGE_ERROR',
  ADD_TASK_TO_INFINITE_LIST: 'ADD_TASK_TO_INFINITE_LIST',
  REMOVE_TASK_FROM_INFINITE_LIST: 'REMOVE_TASK_FROM_INFINITE_LIST',
  INFINITE_LIST_ITEM_DRAG_N_DROP_ACTION: 'INFINITE_LIST_ITEM_DRAG_N_DROP_ACTION',
  INFINITE_LIST_ITEM_SECTION_CHANGE_ACTION: 'INFINITE_LIST_ITEM_SECTION_CHANGE_ACTION',
  MERGE_CHART_PREVIEW_TASKS: 'MERGE_CHART_PREVIEW_TASKS',
};
